<template>
  <div id="chat-user-list">
    <div class="item">
      <div class="label">群名称</div>
      <div class="desc">
        <el-input v-model="projectTitle" v-if="showEdit">
          <div slot="suffix" class="btn-box">
            <i class="el-icon-close btn" @click="cancelModify"></i>
            <i class="el-icon-check btn" @click="saveModify"></i>
          </div>
        </el-input>
        <span v-else>{{chatMessage.title}}</span>
        <i v-if="!showEdit" class="el-icon-edit btn btn-plus" @click="modifyUser"></i>
      </div>
    </div>
    <div class="item">
      <div class="label">{{users.length}}人</div>
      <div class="desc">
        <span>添加群成员</span>
        <i class="el-icon-plus btn btn-plus" @click="userHandle"></i>
      </div>
    </div>
    <div class="user-list">
      <div v-for="(item, idx) in users" :key="idx" class="user">
        <span class="name">
          {{item.name}}
          <i class="tag" v-if="chatMessage && chatMessage.user_id == item.ID">群主</i>
        </span>
        <span>
          <i
            v-if="chatMessage && chatMessage.user_id != item.ID"
            class="el-icon-remove btn-del"
            @click="deletUser(item, idx)"
          ></i>
        </span>
      </div>
    </div>
    <div class="keyword user-info" v-if="false">
      <el-button type="success" @click="userHandle">加人</el-button>
    </div>
    <el-dialog :visible.sync="showUser" width="40" title="这里找人" :append-to-body="true">
      <user
        :show_user="showUser"
        :group_users="users"
        :room_id="currentGroup"
        v-on:complete_event="complete_event"
      />
    </el-dialog>
  </div>
</template>
<script>
import User from "../components/User.vue";
export default {
  components: { User },
  props: { users: Array, chatMessage: Object, currentGroup: [String, Number] },
  data() {
    return {
      current_user: JSON.parse(localStorage.getItem("user")),
      showUser: false,
      showEdit: false,
      projectTitle: ""
    };
  },
  created() {
    this.projectTitle = this.chatMessage.title;
    console.log("users:", this.users);
  },
  methods: {
    cancelModify() {
      this.showEdit = false;
      this.projectTitle = this.chatMessage.title;
    },
    saveModify() {
      console.log("save:", this.chatMessage, this.projectTitle);
      this.$api
        .handleRoomInfo({
          id: this.chatMessage.ID,
          title: this.projectTitle,
          update: true
        })
        .then(res => {
          if (res.code == 200) {
            this.$message.success({ message: res.msg });
            this.showEdit = false;
            this.$emit("complete_event");
          }
        });
    },
    modifyUser() {
      this.showEdit = true;
    },
    deletUser(user, idx) {
      var that = this;
      this.$confirm("踢除成员", {
        title: "踢除成员",
        message: `确定将${user.name}移出群吗?`,
        type: "warning"
      }).then(res => {
        this.removeUserFromRoom(user, idx);
      });
    },
    removeUserFromRoom(user, idx) {
      this.$api
        .deleteUser({
          id: this.chatMessage.ID,
          user_id: user.ID,
          remove: user.ID
        })
        .then(res => {
          if (res.code == 200) {
            this.$message.success({ message: res.msg });
            this.$emit("delUser", idx);
            // this.users.splice(idx, 1);
          }
        });
    },
    userHandle() {
      this.showUser = true;
    },
    complete_event(isAdded) {
      this.$emit("complete_event", isAdded);
      this.showUser = false;
    }
  }
};
</script>
<style lang="scss" scoped>
#chat-user-list {
  // padding: 0 30px;
  .item {
    margin: 0 30px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    // border: 1px dashed red;
    .label {
      color: hsla(0, 0%, 60%, 1);
    }
    .desc {
      color: hsla(0, 0%, 20%, 1);
      .btn-box {
        height: 100%;
        display: flex;
        align-items: center;
      }
      .btn-plus {
        margin-left: 10px;
        font-weight: bold;
      }
    }
  }
  .user-list {
    height: 515px;
    overflow-y: auto;
    .user {
      margin: 0 30px;
      padding: 12px 0;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid hsla(0, 0%, 90%, 1);
      // border: 1px dashed red;
      .name {
        font-size: 14px;
        color: hsla(0, 0%, 20%, 1);
        .tag {
          margin-left: 10px;
          padding: 0.1em 0.6em;
          color: hsla(0, 0%, 20%, 1);
          background: hsla(54, 100%, 61%, 1);
          border-radius: 3px 3px 3px 0px;
          font-style: normal;
          font-size: 12px;
        }
      }
      .btn-del {
        color: hsla(359, 100%, 65%, 1);
        cursor: pointer;
      }
      .btn-del:hover {
        color: hsla(352, 98%, 41%, 1);
      }
    }
    .href {
      color: #3a92f2;
      font-size: 12px;
    }
    .user-info {
      justify-content: space-between;
      box-sizing: border-box;
      padding: 12px 18px;
    }
  }
}
@media screen and (max-width: 720px) {
  /deep/ .el-dialog{
    width: 100%;
  }
}
</style>